<template>
  <el-radio-group
    v-model="selectedWorkoutType"
    class="justify-content-center align-items-center px-6 py-3"
    size="large"
  >
    <el-radio-button
      v-for="{ workout_count, workout_type_record } in dataWorkoutTypes"
      :key="workout_type_record.workout_type_id"
      :label="workout_type_record.workout_type_id"
      :value="workout_type_record.workout_type_id"
      class="workout-type-pill ms-3"
      @click="selectWorkoutType(workout_type_record)"
    >
      {{ workout_type_record.workout_name }} ({{ workout_count }})
    </el-radio-button>
  </el-radio-group>
</template>

<script>
export default {
  name: "WorkoutTypes",
  props: {
    dataWorkoutTypes: {
      type: Array,
      required: true,
    },
    selectedWorkoutTypeId: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-workout-type-id"],
  data() {
    return {
      selectedWorkoutType: -1,
    };
  },
  watch: {
    selectedWorkoutTypeId(newValue) {
      this.selectedWorkoutType = newValue;
    },
  },
  mounted() {
    // auto select first record if selecteWorkoutType = -1
    if (this.selectedWorkoutTypeId == -1) {
      this.selectedWorkoutType =
        this.dataWorkoutTypes.length > 0
          ? this.dataWorkoutTypes[0].workout_type_record.workout_type_id
          : -1;
    }
  },
  methods: {
    selectWorkoutType(workoutTypeRecord) {
      this.$emit("selected-workout-type-id", workoutTypeRecord.workout_type_id);
    },
  },
};
</script>

<style lang="scss" scoped>
:export {
  primary: $primary;
}

.workout-type-pill {
  border-radius: 24px;
  border: 2px solid white;

  &.is-active {
    border-color: $primary;
  }
  &:hover {
    border-color: $primary;
  }
}
</style>
